export default [
  {
    url: '1field.jpg',
    caption: 'SOUVENIR 159 - BRICK LAMP NO.2'
  },
  {
    url: '2field.jpg',
    caption: 'SOUVENIR 150 - SPRING TABLE NO.1'
  },
  {
    url: '3field.jpg',
    caption: 'SOUVENIR 168 - 167 - LASER PRINT STREET POSTER'
  },
  {
    url: '4field.jpg',
    caption: 'DETAIL: SOUVENIR 146 - COUNTERWEIGHT LIGHT NO.1'
  },
  {
    url: '5field.jpg',
    caption: 'INSTALLATION VIEW: SOUVENIR SHOP, 2014'
  },
  {
    url: '6field.jpg',
    caption: 'INSTALLATION VIEW: SOUVENIR SHOP, 2014'
  },
  {
    url: '7field.jpg',
    caption: 'EXPERIMENT 058 - 062 - BOTTLES'
  },
  {
    url: '8field.jpg',
    caption: 'INSTALLATION VIEW: SOUVENIR SHOP, 2014'
  },
  {
    url: '9field.jpg',
    caption: 'EXPERIMENT 038 - AD HOC FURNITURE '
  },
  {
    url: '10field.jpg',
    caption: 'PAPERWEIGHT BOOK'
  },
  {
    url: '11field.jpg',
    caption: 'INTERIOR VIEW: PAPERWEIGHT BOOK'
  },
  {
    url: '12field.jpg',
    caption: 'SOUVENIR 161 - LIMP LAMP'
  },
  {
    url: '13field.jpg',
    caption: 'SOUVENIR 140 - BRICK CANDLE NO.6'
  },
  {
    url: '15field.jpg',
    caption: 'DETAIL VIEW: SOUVENIR 148 - RUBBER VASE'
  },
  {
    url: '16field.jpg',
    caption: 'INDONESIA PUBLICATION'
  },
  {
    url: '17field.jpg',
    caption: 'SOUVENIR 169 - WEEDS AND PAVEMENT NO.1'
  },
  {
    url: '18field.jpg',
    caption: 'SOUVENIR 172 - WEEDS AND PAVEMENT NO.4'
  },
  {
    url: '19field.jpg',
    caption: 'SOUVENIR 154 - SIDE TABLE'
  },
  {
    url: '20field.jpg',
    caption: 'SOUVENIR 141 - BRICK CANDLE NO.7'
  },
  {
    url: '21field.jpg',
    caption: 'INSTALLATION VIEW: HARDLY TOGETHER, 2017'
  },
  {
    url: '22field.jpg',
    caption: 'INTERIOR VIEW: GROUNDS FOR PLAY PUBLICATION'
  },
  {
    url: '23field.jpg',
    caption: 'INSTALLATION VIEW: GROUNDS FOR PLAY, 2015'
  },
  {
    url: '24field.jpg',
    caption: 'INSTALLATION VIEW: GROUNDS FOR PLAY, 2015'
  },
  {
    url: '25field.jpg',
    caption: 'INSTALLATION VIEW: GROUNDS FOR PLAY, 2015'
  },
  {
    url: '26field.jpg',
    caption: 'INTERIOR VIEW: GROUNDS FOR PLAY PUBLICATION'
  },
  {
    url: '27field.jpg',
    caption: 'EXPERIMENT 001 - LIMESTONE POSTER'
  },
  {
    url: '28field.jpg',
    caption: 'EXPERIMENT 020 - LIMESTONE & TEAK CRYSTAL'
  },
  {
    url: '29field.jpg',
    caption: 'INSTALLATION VIEW: SOUVENIR SHOP, 2014'
  },
  {
    url: '30field.jpg',
    caption: 'INTERIOR VIEW: INDONESIA PUBLICATION'
  },
  {
    url: '31field.jpg',
    caption: 'EXPERIMENT 063 - 065 - BOTTLES'
  },
  {
    url: '32field.jpg',
    caption: 'EXPERIMENT 079 - TOTEM'
  },
  {
    url: '33field.jpg',
    caption: 'EXPERIMENT 083 - 092 - INFLATABLES'
  },
  {
    url: '34field.jpg',
    caption: 'INTERIOR VIEW: INDONESIA PUBLICATION'
  },
  {
    url: '35field.jpg',
    caption: 'INSTALLATION VIEW: HARDLY TOGETHER, 2017'
  },
  {
    url: '36field.jpg',
    caption: 'INSTALLATION VIEW: HARDLY TOGETHER, 2017'
  },
  {
    url: '37field.jpg',
    caption: 'SOUVENIR155 - DOMESTIC LIGHT NO.1'
  },
  {
    url: '38field.jpg',
    caption: 'SOUVENIR135 - BRICK CANDLE NO.1'
  },
  {
    url: '39field.jpg',
    caption: 'SOUVENIR 149 - FLOOR FAN'
  },
  {
    url: '40field.jpg',
    caption: 'INSTALLATION VIEW: HARDLY TOGETHER, 2017'
  },
  {
    url: '41field.jpg',
    caption: 'SOUVENIR 165 - 1666 - LASER PRINT STREET POSTER'
  },
  {
    url: '42field.jpg',
    caption: 'INTERIOR VIEW: GROUNDS FOR PLAY PUBLICATION'
  },
  {
    url: '43field.jpg',
    caption: 'INSTALLATION VIEW: GROUNDS FOR PLAY, 2015'
  },
  {
    url: '44field.jpg',
    caption: 'SOUVENIR 173 - WEEDS AND PAVEMENT NO.5'
  },
  {
    url: '45field.jpg',
    caption: 'EXPERIMENT 102 - KITE'
  },
  {
    url: '46field.jpg',
    caption: 'INSTALLATION VIEW: GROUNDS FOR PLAY, 2015'
  }
]
